import { useState } from "react";
import { useAlert } from "../../../hooks/useAlert";
import { getErrorMessage } from "../../../utils";
import {
  CLEAR_CACHE_BUTTON_TITLE,
  clearSiteCacheAndReload,
} from "../../../utils/clearSiteCache";

type ClearCacheButtonProps = {
  compact?: boolean;
};

export default function ClearCacheButton({ compact = false }: ClearCacheButtonProps) {
  const [clearingCache, setClearingCache] = useState(false);
  const { showAlert } = useAlert();

  const handleClearCache = async () => {
    if (clearingCache) return;
    setClearingCache(true);
    try {
      await clearSiteCacheAndReload();
    } catch (err) {
      setClearingCache(false);
      showAlert(
        getErrorMessage({ title: "Error al borrar caché y cookies", err }),
      );
    }
  };

  return (
    <div className={`sidebar-clear-cache${compact ? " is-compact" : ""}`}>
      <button
        type="button"
        title={CLEAR_CACHE_BUTTON_TITLE}
        aria-label={CLEAR_CACHE_BUTTON_TITLE}
        onClick={handleClearCache}
        disabled={clearingCache}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
          <path d="M10 11v6M14 11v6" />
          <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
        </svg>
        {!compact && (
          <span>{clearingCache ? "Borrando..." : "Borrar Caché y cookies"}</span>
        )}
      </button>
    </div>
  );
}
